<template>
  <ClinicalForm
    form-key-prefix="visit"
    :title="'Patient Data Collection'"
    :chapter="chapter"
  />
</template>

<script>
// "Patient Data Collection" visit form, organised into chapters
// (anthropometrics, smoking, medication, morbidities, comorbidities, …).
// Schema reconstructed from the bundle -> src/forms/schemas/visit.js.
//
// TODO(schema): populate per-chapter schemas and verify against the live app.
import ClinicalForm from 'components/ClinicalForm.vue'
export default {
  name: 'VisitView',
  components: { ClinicalForm },
  computed: {
    chapter() {
      return this.$route.params.chapter || null
    },
  },
}
</script>
